import { FormInput, Loader } from "@/components";
import { Button, Checkbox } from "@/components/ui";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui";
import { FormProvider } from "react-hook-form";
import { PASSWORD, EMAIL } from "./consts";
import useLogin from "./useLogin";
import logo from "@/assets/logo.png";
import { UserIcon } from "lucide-react";

const Login = () => {
  const {
    form,
    onSubmit,
    requiredFields,
    onEyeIconClick,
    isPassword,
    Icon,
    isLoginPending,
    onForgotClick,
  } = useLogin();
  const { errors } = form.formState;

  return (
    <div className="flex md:flex-row w-full h-[100vh]">
      <div className="hidden bg-[url('/loginCover.png')] bg-cover bg-no-repeat md:flex flex-col w-1/2 bg-blue-900 text-white p-8 relative">
        <div className="absolute z-10 bg-linear-to-br from-secondary to-primary-700 opacity-[00.9] h-full w-full top-0 left-0"></div>
        <img src={logo} className="h-auto w-40 z-20" />
      </div>
      <div
        className={`w-full md:w-1/2 bg-[url('/loginCoverRight.png')] bg-cover bg-no-repeat`}
      >
        <div className="bg-[url('/loginCoverObjects.png')] bg-cover bg-no-repeat flex flex-col justify-center items-center p-8 h-full">
          <FormProvider {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)}>
              <Card className="w-full lg:w-[400px]">
                <CardHeader className="my-[20px]">
                  <CardTitle className="text-center font-[500] text-[24px]">
                    Login
                  </CardTitle>
                  <span className="text-[14px] text-g-400 text-center font-extralight">
                    Access to our dashboard
                  </span>
                </CardHeader>
                <CardContent>
                  <div className="flex flex-col gap-5">
                    <div>
                      <label className="text-[14px] font-[400]">Username</label>
                      <FormInput
                        name={EMAIL}
                        control={form.control}
                        placeholder="Please enter"
                        error={errors[EMAIL]?.message}
                        isRequired={requiredFields.includes(EMAIL)}
                        endIcon={<UserIcon className="h-4 w-4" />}
                      />
                    </div>
                    <div>
                      <label className="text-[14px] font-[400]">Password</label>
                      <FormInput
                        name={PASSWORD}
                        control={form.control}
                        placeholder="Please enter"
                        error={errors[PASSWORD]?.message}
                        isRequired={requiredFields.includes(PASSWORD)}
                        type={isPassword ? "password" : "text"}
                        endIcon={
                          <Icon className="h-4 w-4" onClick={onEyeIconClick} />
                        }
                      />
                    </div>
                    <div className="flex items-center justify-between">
                      <div className="flex items-center">
                        <Checkbox />
                        <span className="text-[13px] font-normal ml-2">
                          Remember me
                        </span>
                      </div>
                      <Button
                        type="button"
                        variant="link"
                        className="text-[13px] text-black-300 text-end p-0 m-0 h-[20px] no-underline font-[400]"
                        onClick={onForgotClick}
                      >
                        Forgot Password?
                      </Button>
                    </div>
                  </div>
                </CardContent>
                <CardFooter>
                  <Button
                    type="submit"
                    className="w-full"
                    disabled={isLoginPending}
                  >
                    {isLoginPending ? <Loader variant="secondary" /> : ""} Login
                  </Button>
                </CardFooter>
              </Card>
            </form>
          </FormProvider>
        </div>
      </div>
    </div>
  );
};

export default Login;
